import Handsontable from 'handsontable'

export interface FindAndReplacePopoverProps {
  hotTable: Handsontable
  colIdx: number
  listValues?: string[]
}

export interface Change {
  previousTerm: string
  newTerm: string
  rowIdx: number
}

export type GroupedChanges = Record<string, Change[]>

export interface RecentChangesProps {
  recentChanges: Change[]
  undoChange: (group: Change[]) => void
}

interface SearchResult {
  row: number
  col: number
  data: string
}

export interface FooterProps {
  disableButtons: boolean
  replaceSingleOccurence: () => void
  replaceAllOccurrences: () => void
}

export interface SelectProps {
  onChange: (string) => void
  listValues: string[]
}

export interface State {
  find: string
  replace: string
  matchCase: boolean
  searchResults: SearchResult[]
  selectedResultIndex: number
  recentChanges: Change[]
}

export enum ActionType {
  clearSearch = 'clearSearch',
  setFind = 'setFind',
  setReplace = 'setReplace',
  toggleMatchCase = 'toggleMatchCase',
  setSearchResults = 'setSearchResults',
  setSelectedResultIndex = 'setSelectedResultIndex',
  setRecentChanges = 'setRecentChanges',
  recordChange = 'recordChange',
  undoChange = 'undoChange',
}

export type Action =
  | { type: ActionType.clearSearch }
  | { type: ActionType.setFind; payload: string }
  | { type: ActionType.setReplace; payload: string }
  | { type: ActionType.toggleMatchCase }
  | { type: ActionType.setSearchResults; payload: SearchResult[] }
  | { type: ActionType.setSelectedResultIndex; payload: number }
  | { type: ActionType.setRecentChanges; payload: Change[] }
  | { type: ActionType.recordChange; payload: Change }
  | { type: ActionType.undoChange; payload: Change }
